export const enum NotificationType {
    Ticket = 0,
    Announcement = 1,
    Upload = 2,
    Subscription = 3,
    CCTVDesignerOutputFilesResult = 4,
    DnaExportResult = 5,
    DnaImportResult = 7,
    SystemSoftwareParametersExportResult = 8,
    Administration = 10
}

export const NotificationTypes: Array<any> =
    [
        { text: 'Ticket', id: NotificationType.Ticket },
        { text: 'Announcement', id: NotificationType.Announcement },
        { text: 'Upload', id: NotificationType.Upload },
        { text: 'Subscription', id: NotificationType.Subscription },
        { text: 'CCTVDesignerOutputFilesResult', id: NotificationType.CCTVDesignerOutputFilesResult },
        { text: 'DnaExportResult', id: NotificationType.DnaExportResult },
        { text: 'DnaImportResult', id: NotificationType.DnaImportResult },
        { text: 'SystemSoftwareParametersExportResult', id: NotificationType.SystemSoftwareParametersExportResult },
        { text: 'Administration', id: NotificationType.Administration }
    ];
